import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Accueil', href: '/' },
  { name: 'Qui sommes nous', href: '/qui-sommes-nous' },
  { name: 'Prudens Résidence', href: '/residence' },
  { name: 'Prudens Téléconciergerie', href: '/teleconciergerie' },
];

const Navbar: React.FC = () => {
  const location = useLocation();

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <Disclosure as="nav" className="bg-white shadow-md sticky top-0 z-50">
      {({ open }) => (
        <>
          <div className="container-custom">
            <div className="relative flex h-20 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-prudens-bleu-grise hover:bg-prudens-beige-sable hover:text-prudens-bleu-fonce focus:outline-none focus:ring-2 focus:ring-inset focus:ring-prudens-bleu-clair">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Ouvrir le menu principal</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex flex-shrink-0 items-center">
                  <Link to="/">
                    <img 
                    src="/logo.png" 
                    alt="logo Prudens" 
                    className="h-10 w-auto" 
                    />
                  </Link>
                </div>
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={classNames(
                          item.href === location.pathname
                            ? 'bg-prudens-bleu-fonce text-white'
                            : 'text-prudens-bleu-grise hover:bg-prudens-beige-sable hover:text-prudens-bleu-fonce',
                          'rounded-md px-3 py-2 text-sm font-medium'
                        )}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="hidden sm:flex items-center sm:ml-6">
                <a
                  href="mailto:contact@prudens-france.fr?subject=Demande%20d'information"
                  className="btn btn-secondary"
                >
                  Nous Contacter
                </a>
              </div>
            </div>
          </div>

          {/* Overlay pour fermer le menu en cliquant à l'extérieur (mobile) */}
          {open && (
            <Disclosure.Button
              as="div"
              aria-hidden="true"
              className="fixed inset-0 bg-black/20 sm:hidden"
            />
          )}

          <Disclosure.Panel className="sm:hidden relative z-50">
            <div className="space-y-1 px-2 pb-3 pt-2 bg-white shadow-lg">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={classNames(
                    item.href === location.pathname
                      ? 'bg-prudens-bleu-fonce text-white'
                      : 'text-prudens-bleu-grise hover:bg-prudens-beige-sable hover:text-prudens-bleu-fonce',
                    'block rounded-md px-3 py-2 text-base font-medium'
                  )}
                >
                  {item.name}
                </Link>
              ))}
              <div className="mt-4 px-3">
                <a
                  href="mailto:contact@prudens-france.fr?subject=Demande%20d'information"
                  className="btn btn-secondary w-full text-center block"
                >
                  Nous contacter
                </a>
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default Navbar; 